import { create } from 'zustand';

export const useAppStore = create((set, get) => ({
  vendor: null,
  branch: null,
  gstRate: 18,

  setVendor: (vendor) => {
    set({ vendor });
    if (vendor) {
      localStorage.setItem('selectedVendor', JSON.stringify(vendor));
    } else {
      localStorage.removeItem('selectedVendor');
    }
  },

  setBranch: (branch) => {
    set({ branch });
    if (branch) {
      localStorage.setItem('selectedBranch', JSON.stringify(branch));
    } else {
      localStorage.removeItem('selectedBranch');
    }
  },

  setGSTRate: (gstRate) => {
    set({ gstRate });
    localStorage.setItem('gstRate', gstRate.toString());
  },

  // Initialize from localStorage
  initializeFromStorage: () => {
    try {
      const savedVendor = localStorage.getItem('selectedVendor');
      const savedBranch = localStorage.getItem('selectedBranch');
      const savedGSTRate = localStorage.getItem('gstRate');

      const updates = {};

      if (savedVendor) {
        updates.vendor = JSON.parse(savedVendor);
      }

      if (savedBranch) {
        updates.branch = JSON.parse(savedBranch);
      }

      if (savedGSTRate) {
        updates.gstRate = parseFloat(savedGSTRate);
      }

      if (Object.keys(updates).length > 0) {
        set(updates);
      }
    } catch (error) {
      console.error('Error loading from localStorage:', error);
    }
  },

  // Listen for auth events to clear branch on login
  initializeEventListeners: () => {
    const handleAuthLogin = () => {
      set({ branch: null });
    };

    window.addEventListener('auth:login', handleAuthLogin);

    // Return cleanup function
    return () => {
      window.removeEventListener('auth:login', handleAuthLogin);
    };
  },

  getters: {
    getCurrentVendor: () => {
      const { vendor } = get();
      return vendor;
    },
    getCurrentBranch: () => {
      const { branch } = get();
      return branch;
    },
  }
}));
